<template>
  <b-container class="div-background" fluid>
    <b-breadcrumb :items="breadcrumbItems" class="minus-gutters"></b-breadcrumb>
    <b-alert
      variant="success"
      :show="messageObject.success.count"
      dismissible
      @dismissed="messageObject.success.count = 0"
      @dismiss-count-down="successCountChanged"
      >{{ messageObject.success.content }}
    </b-alert>
    <!-- <b-alert variant="warning" show>等待資訊</b-alert> -->
    <div class="Info_Area">
      <b-container fluid>
        <b-row align-h="between">
          <b-col cols="9">
            <!-- <b-form-datepicker
                            :date-disabled-fn="dateDisabled"
                            :max="maxdate"
                            size="sm"
                            v-model="date"
                            @context="datechange"
                            >
                        </b-form-datepicker> -->
            <b-input-group>
              <b-input-group-prepend is-text>
                <b-icon icon="calendar3"></b-icon>
              </b-input-group-prepend>
              <datepicker
                v-model="date"
                style="max-width: fit-content;"
                min="1960-01-01"
                :max="maxdate"
              ></datepicker>
            </b-input-group>
          </b-col>
          <b-col cols="auto">
            <b-button @click="modalshow = !modalshow" variant="warning"
              >新增品項</b-button
            >
          </b-col>
        </b-row>
        <b-row>
          <b-col style="height:30px;"></b-col>
        </b-row>
        <b-row>
          <b-col cols="auto">
            <b-table-simple>
              <b-thead head-variant="dark">
                <b-tr class="thead-dark">
                  <b-th rowspan="2">
                    <b-form-checkbox
                      id="checkbox-1"
                      v-model="ifSorting"
                      name="checkbox-1"
                      :value="true"
                      :unchecked-value="false"
                      >排序
                    </b-form-checkbox></b-th
                  >
                  <b-th>魚種</b-th>
                  <!-- <b-th colspan="3">批發交易行情 (元/公斤)</b-th> -->
                  <b-th v-if="window.width > 650">收成規格</b-th>
                  <!-- <b-th rowspan="3">交易行情平均價(元/公斤)</b-th> -->
                  <b-th v-if="window.width >= 1440" rowspan="4"
                    >池邊價格 (元/公斤)</b-th
                  >
                  <b-th v-if="window.width >= 1440" rowspan="4"
                    >池邊價格 (元/台斤)</b-th
                  >
                  <b-th v-if="window.width >= 1440" rowspan="2"
                    >備註及說明</b-th
                  >
                  <b-th v-if="ifshowdelete" rowspan="2">操作</b-th>
                </b-tr>
              </b-thead>
              <template v-if="!ifSorting">
                <b-tbody>
                  <template v-for="(item, index) in priceanalysis.items">
                    <b-tr :key="index">
                      <b-td>
                        {{ item.FM_SORT }}
                      </b-td>
                      <b-td>
                        {{ item.FISH_NAME }}
                      </b-td>
                      <template v-if="window.width > 650">
                        <b-td>
                          <b-form-input
                            v-model="item.FISH_SPEC"
                            type="text"
                          ></b-form-input>
                        </b-td>
                      </template>
                      <template v-if="window.width >= 1440">
                        <b-td>
                          <b-form-input
                            style="width: 5rem; display: inline-block;"
                            v-model="item.FM_PRICE_L"
                            type="number"
                            @update="unitTransfer(item, 0, 0)"
                          ></b-form-input>
                          -
                          <b-form-input
                            style="width: 5rem; display: inline-block;"
                            v-model="item.FM_PRICE_R"
                            type="number"
                            @update="unitTransfer(item, 0, 1)"
                          ></b-form-input>
                        </b-td>
                        <b-td>
                          <b-form-input
                            style="width: 5rem; display: inline-block;"
                            v-model="item.FM_PRICE_L_TW"
                            type="number"
                            @update="unitTransfer(item, 1, 0)"
                          ></b-form-input>
                          -
                          <b-form-input
                            style="width: 5rem; display: inline-block;"
                            v-model="item.FM_PRICE_R_TW"
                            type="number"
                            @update="unitTransfer(item, 1, 1)"
                          ></b-form-input>
                        </b-td>
                        <b-td>
                          <b-form-textarea
                            v-model="item.FM_NOTES"
                            rows="3"
                          ></b-form-textarea>
                        </b-td>
                      </template>
                      <b-td>
                        <b-button
                          v-if="window.width < 1440"
                          @click="item.ifshow = !item.ifshow"
                          style="margin-bottom: 0.1rem; margin-right: 0.1rem;"
                          variant="success"
                          >{{ item.ifshow ? "隱藏" : "詳細" }}</b-button
                        >
                        <b-button
                          v-if="ifshowdelete"
                          @click="removeProcess(item)"
                          style="margin-bottom: 0.1rem;"
                          variant="danger"
                          >刪除</b-button
                        >
                      </b-td>
                    </b-tr>
                    <b-tr v-if="item.ifshow" :key="'detial' + index">
                      <b-td colspan="6">
                        <b-card>
                          <b-row v-if="window.width <= 650" class="mb-2">
                            <b-col sm="3" class="text-sm-right"
                              ><b>收成規格:</b></b-col
                            >
                            <b-col
                              ><b-form-input
                                v-model="item.FISH_SPEC"
                                type="text"
                              ></b-form-input
                            ></b-col>
                          </b-row>
                          <b-row class="mb-2">
                            <b-col sm="3" class="text-sm-right"
                              ><b>池邊價格 (元/公斤):</b></b-col
                            >
                            <b-col>
                              <b-form-input
                                v-model="item.FM_PRICE_L"
                                type="number"
                                @update="unitTransfer(item, 0, 0)"
                              ></b-form-input>
                              -
                              <b-form-input
                                v-model="item.FM_PRICE_R"
                                type="number"
                                @update="unitTransfer(item, 0, 1)"
                              ></b-form-input>
                            </b-col>
                          </b-row>
                          <b-row class="mb-2">
                            <b-col sm="3" class="text-sm-right"
                              ><b>池邊價格 (元/台斤):</b></b-col
                            >
                            <b-col>
                              <b-form-input
                                v-model="item.FM_PRICE_L_TW"
                                @update="unitTransfer(item, 1, 0)"
                                type="number"
                              ></b-form-input>
                              -
                              <b-form-input
                                v-model="item.FM_PRICE_R_TW"
                                @update="unitTransfer(item, 1, 1)"
                                type="number"
                              ></b-form-input>
                            </b-col>
                          </b-row>
                          <b-row class="mb-2">
                            <b-col sm="3" class="text-sm-right"
                              ><b>備註及說明:</b></b-col
                            >
                            <b-col
                              ><b-form-textarea
                                v-model="item.FM_NOTES"
                                rows="3"
                              ></b-form-textarea
                            ></b-col>
                          </b-row>
                          <b-row class="mb-2">
                            <b-button
                              variant="success"
                              @click="item.ifshow = !item.ifshow"
                              >確定</b-button
                            >
                          </b-row>
                        </b-card>
                      </b-td>
                    </b-tr>
                  </template>
                </b-tbody>
              </template>
              <template v-else-if="ifSorting">
                <draggable
                  tag="tbody"
                  v-model="priceanalysis.items"
                  force-fallback="true"
                  animation="1000"
                  @end="onEnd"
                >
                  <b-tr
                    v-for="(item, index) in priceanalysis.items"
                    :key="index"
                  >
                    <b-td>
                      {{ item.FM_SORT }}
                    </b-td>
                    <b-td>
                      {{ item.FISH_NAME }}
                    </b-td>
                    <b-td>
                      {{ item.FISH_SPEC }}
                    </b-td>
                    <b-td> {{ item.FM_PRICE_L }} - {{ item.FM_PRICE_R }} </b-td>
                    <b-td>
                      {{ item.FM_PRICE_L_TW }} - {{ item.FM_PRICE_R_TW }}
                    </b-td>
                    <b-td>
                      {{ item.FM_NOTES }}
                    </b-td>
                    <b-td>
                      <b-button
                        v-if="ifshowdelete"
                        @click="removeProcess(item)"
                        variant="danger"
                        >刪除</b-button
                      >
                    </b-td>
                  </b-tr>
                </draggable>
              </template>
            </b-table-simple>
          </b-col>
        </b-row>
        <b-row align-h="center">
          <b-col>
            <b-button @click="getToken" variant="warning">儲存</b-button>
          </b-col></b-row
        >
      </b-container>
      <!-- <b-modal title="新增品項" id="addFishModal" @hidden="hideModal" @ok="addProcess"> -->
      <b-modal
        size="lg"
        body-class="bmodal-body"
        v-model="modalshow"
        title="新增品項"
        id="addFishModal"
        hide-backdrop
        @hidden="hideModal"
        @ok="addProcess"
      >
        <b-form-group
          label="*請選擇市場作物"
          label-for="marketselect"
          label-cols-sm="3"
          label-align-sm="right"
        >
          <v-select
            id="marketselect"
            v-model="fishcatch.selected"
            :options="pasrseToOptions(fishcodelist)"
            height="200px"
            :dense="true"
          ></v-select>
        </b-form-group>
        <template #modal-footer="{ ok, cancel }">
          <b-button size="sm" variant="success" @click="ok()">
            儲存
          </b-button>
          <b-button size="sm" variant="warning" @click="cancel()">
            取消
          </b-button>
        </template>
      </b-modal>
    </div>
  </b-container>
</template>
<script>
import draggable from "vuedraggable";
import datepicker from "@/components/Datepicker.vue";
import FISHCODELIST from "@/data/FISH_CODE_LIST.json";

export default {
  data() {
    const now = new Date();
    const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
    var taiwanMaxDate = today
      .toLocaleString()
      .split(" ")[0]
      .split("/");
    taiwanMaxDate[0] = parseInt(taiwanMaxDate[0]) - 1911;
    taiwanMaxDate[1] =
      taiwanMaxDate[1].length == 1 ? 0 + taiwanMaxDate[1] : taiwanMaxDate[1];
    taiwanMaxDate[2] =
      taiwanMaxDate[2].length == 1 ? 0 + taiwanMaxDate[2] : taiwanMaxDate[2];
    return {
      num: 10,
      perPage: 5,
      id: this.$route.params.id,
      counter: 0,
      total: 0,
      date: null,
      currentPage: 1,
      editlist: [],
      sortBy: "FM_SORT ",
      modalshow: false,
      ifSorting: false,
      today: taiwanMaxDate.join("-"),
      maxdate: today
        .toLocaleString()
        .split(" ")[0]
        .split("/")
        .join("-"),
      // today: '2021-05-26',
      // mindate: '2021-05-26',
      // maxdate: '2021-05-26',
      filterSearch: null,
      selection: [],
      totalRows: 1,
      Token: null,
      TokenID:
        "4ImX7kJFJSGhLW14LiAP8bbfW7lpO8pvW8uZqIXhFvlhTVhwF4nXhrWjn7NatmmqGrFiKJTOaA40KO+eN0G6pQ==",
      fishcodelist: FISHCODELIST,
      isBusy: true,
      iffirst: true,
      // timepicker: {
      //     minvalue: '2021-06-17',
      //     maxvalue: '2021-06-24',
      //     min: minDate,
      //     max: maxDate,
      // },
      window: {
        width: 1024,
        height: 0,
      },
      removeobj: {},
      filtervalue: null,
      datamanagement: {
        ifshow: false,
        ifedit: false,
      },
      breadcrumbItems: [
        {
          text: "首頁",
          href: "#/",
        },
        {
          text: "資料管理",
          active: true,
        },
        {
          text: "漁產品價格維護",
          href: "#/databuildforfishcatch",
        },
        {
          text: this.$route.params.id == "add" ? "新增" : "編輯",
          active: true,
        },
      ],
      priceanalysis: {
        fields: [
          {
            key: "FM_SORT ",
            label: "排序",
            visible: true,
          },
          {
            key: "FM_DATE",
            label: "日期",
            visible: true,
          },
          {
            key: "FISH_NAME",
            label: "魚種",
            visible: true,
          },
          {
            key: "FISH_SPEC",
            label: "收成規格",
            visible: true,
          },
          {
            key: "FM_PRICE_L",
            label: "池邊價格 (元/公斤)",
            visible: true,
          },
          {
            key: "FM_PRICE_L_TW",
            label: "池邊價格 (元/台斤)",
            visible: true,
          },
          {
            key: "FM_NOTES",
            label: "備註",
            visible: true,
          },
          //{
          //  key: "EDIT",
          //  label: "操作",
          //  visible: true,
          //},
        ],
        items: [],
        allitems: [
          {
            FM_SORT: 0,
            FM_DATE: "2021-05-26",
            FISH_NAME: "白蝦",
            PRICE_AVG: "195.4",
            FISH_SPEC: "50尾/斤",
            FM_PRICE_L: "80",
            FM_NOTES:
              "成本價(混養50-55元、半專養80-85元)，本縣主要產季7-11月。 尚未進入本縣盛產季節，價格於7月前將持續維持高價位。",
          },
          {
            FM_SORT: 1,
            FM_DATE: "2021-05-26",
            FISH_NAME: "金目鱸",
            PRICE_AVG: "92.2",
            FISH_SPEC: "1斤/尾",
            FM_PRICE_L: "50",
            FM_NOTES:
              "1.成本價45元，主要產季6月-翌年1月。 2.大魚在池量充足，加上外銷競爭力大，價格不易再上漲，惟仍可維持相當利潤。",
          },
          {
            FM_SORT: 2,
            FM_DATE: "2021-05-26",
            FISH_NAME: "加州鱸",
            PRICE_AVG: "102.8",
            FISH_SPEC: "1斤/尾",
            FM_PRICE_L: "60",
            FM_NOTES:
              "1.成本價40～45元，產季1-5月。2.大魚在池量合宜沒有過量，價格將維持高價位。",
          },
        ],
        additem: {},
        removelist: [],
      },
      messageObject: {
        warning: {
          content: null,
          count: 0,
        },
        success: {
          content: null,
          count: 0,
        },
        dismissSecs: 3,
      },
      fishcatch: {
        selectlist: [null, null],
        typeoptionslist: [
          { label: "請選擇", code: null, disabled: true },
          { label: "香蕉", code: 0 },
          { label: "鳳梨", code: 1 },
          { label: "木瓜", code: 2 },
        ],
        fishcatchlist: [
          {
            type: "香蕉",
            list: [
              { label: "請選擇", code: null },
              { label: "香蕉", code: "001" },
            ],
          },
          {
            type: "鳳梨",
            list: [
              { label: "請選擇", code: null },
              { label: "金鑽鳳梨", code: "002" },
            ],
          },
          {
            type: "木瓜",
            list: [
              { label: "請選擇", code: null },
              { label: "網室紅肉", code: "003" },
            ],
          },
        ],
        fishcatchoptions: [
          { text: "", value: "001" },
          { text: "金鑽鳳梨", value: "002" },
          { text: "網室紅肉", value: "003" },
        ],
        selected: [],
        options: ["全部", "香蕉", "鳳梨 金鑽鳳梨", "木瓜 網室紅肉"],
        options2: [],
        value: "全部",
      },
      ifshowdelete: false,
      ifprocess: false,
      apiGetTradeWarningCrop: (data) =>
        this.userRequest.post("/API/Default/getTradeWarningCrop", data),
      apiUpdateTradeWarningCrop: (data) =>
        this.userRequest.post("/API/Default/updateTradeWarningCrop", data),
      apiInsertFishManagement: (data) =>
        this.userRequest.post("/API/Default/InsertFishManagement", data),
      apigetFishManagement: (data) =>
        this.userRequest.post("/API/Default/getFishManagement", data),
      apiupdateFishManagement: (data) =>
        this.userRequest.post("/API/Default/UpdateFishManagement", data),
      apiToken: (data) => this.userRequest.post("/API/Default/Token", data),
    };
  },
  components: {
    draggable,
    datepicker,
  },
  created() {
    this.checkLogin();
    // window.addEventListener('resize', this.handleResize);
    // this.handleResize();
    // this.init()
  },
  destroyed() {
    window.removeEventListener("resize", this.handleResize);
  },
  mounted() {
    // this.checkLogin()
    // this.checkPermission()
  },
  methods: {
    checkLogin() {
      let TokenID = sessionStorage.getItem("TokenID");
      if (TokenID) {
        this.checkPermission();
      } else {
        alert("無權限檢視此頁面，請登入帳號");
        this.$router.push({ path: "/login" });
      }
    },
    async checkPermission() {
      this.FunctionToken(this.Authority, {
        PJ_ID: "PJ000000000011",
        fun: this.checkByPJID,
      });
      this.FunctionToken(this.Authority, {
        PJ_ID: "PJ000000000013",
        fun: this.checkByPJIDdelete,
      });
    },
    checkByPJID(value) {
      if (!value) {
        alert("無權限檢視此頁面，將返回首頁");
        this.$router.push({ path: "/" });
      } else {
        window.addEventListener("resize", this.handleResize);
        this.handleResize();
        this.init();
      }
    },
    checkByPJIDdelete(value) {
      if (value) this.ifshowdelete = true;
      else this.ifshowdelete = false;
    },
    InsertFishManagement(data) {
      this.apiInsertFishManagement(data)
        .then((res) => {
          const json = JSON.parse(res.data);
          if (json.Status) {
            this.counter++;
            this.checkIfdone2();
          }
        })
        .catch((err) => {
          console.warn(err);
        });
    },
    InsertFishManagementlist(data) {
      this.apiInsertFishManagement(data)
        .then((res) => {
          const json = JSON.parse(res.data);
          if (json.Status) {
            this.counter++;
            this.checkIfdone();
          }
        })
        .catch((err) => {
          console.warn(err);
        });
    },
    getFishManagement(data) {
      this.apigetFishManagement(data)
        .then((res) => {
          const json = JSON.parse(res.data);
          let jsonData = JSON.parse(json.Data);
          if (json.Status) {
            let list = [];
            for (let g in jsonData) {
              let subitem = jsonData[g];
              subitem["ifshow"] = false;
              if (subitem.FM_ISDEL == 0) {
                list.push(subitem);
              }
            }
            this.priceanalysis.items = JSON.parse(JSON.stringify(list));
            this.priceanalysis.items.sort((a, b) => {
              let y = (a.FM_SORT > b.FM_SORT) - (a.FM_SORT < b.FM_SORT);
              return y;
            });
            for (let x in this.priceanalysis.items) {
              let subitem2 = this.priceanalysis.items[x];
              subitem2["FM_SORT"] = parseInt(x) + 1;
            }
            this.isBusy = false;
          }
        })
        .catch((err) => {
          console.warn(err);
        });
    },
    getToken() {
      this.apiToken({})
        .then((res) => {
          if (!this.ifprocess) {
            this.ifprocess = true;
            this.Token = res.data;
            this.savelist();
          }
        })
        .catch((error) => {
          alert("發生錯誤!" + error);
        });
    },
    getToken2() {
      this.apiToken({})
        .then((res) => {
          this.Token = res.data;
          let obj = this.removeobj;
          obj["FM_ISDEL"] = 1;
          obj["Token"] = this.Token;
          obj["Page"] = this.page;
          this.FunctionToken(this.removeCropManagement, [obj]);
        })
        .catch((error) => {
          alert("發生錯誤!" + error);
        });
    },
    updateFishManagement(data) {
      this.apiupdateFishManagement(data)
        .then((res) => {
          const json = JSON.parse(res.data);
          if (json.Status) {
            this.counter++;
            this.checkIfdone2();
          }
        })
        .catch((err) => {
          console.warn(err);
        });
    },
    //  checkLogin() {
    //     let TokenID = sessionStorage.getItem("TokenID");
    //     if(TokenID){
    //         this.checkPermission()
    //     }
    //     else
    //     {
    //         alert("無權限檢視此頁面，請登入帳號")
    //         this.$router.push({ path: '/login' })
    //     }
    // },
    init() {
      this.date = this.id == "add" ? this.today : this.id;
      //this.datechange();
      // let localmintime = this.date.split("-");
      // localmintime[0] = parseInt(localmintime[0]) + 1911;
      // let obj = {
      //   FM_DATE: localmintime.join("-"),
      // };
      // this.FunctionToken(this.getFishManagement, obj);
      // this.priceanalysis.items = JSON.parse(JSON.stringify(this.priceanalysis.allitems))
    },
    handleResize() {
      this.window.width = window.innerWidth;
      this.window.height = window.innerHeight;
    },
    onEnd() {
      for (let j in this.priceanalysis.items) {
        let item1 = this.priceanalysis.items[j];
        item1["FM_SORT"] = parseInt(j) + 1;
      }
    },
    dateDisabled(ymd, date) {
      // Disable weekends (Sunday = `0`, Saturday = `6`)
      // let y = ymd
      const weekday = date.getDay();
      // Return `true` if the date should be disabled
      return weekday === 0 || weekday === 6;
    },
    removeProcess(item) {
      if (confirm("確定要刪除品項?")) {
        if (this.IsNull(item["FM_ID"]) != "") {
          this.priceanalysis.removelist.push(item);
        }
        let index = this.priceanalysis.items.findIndex(
          (y) => y.FISH_NAME == item.FISH_NAME
        );
        this.priceanalysis.items.splice(index, 1);
      }
    },
    removeCropManagement(data) {
      this.apiupdateFishManagement(data)
        .then((res) => {
          const json = JSON.parse(res.data);
          if (json.Status) {
            let index = this.priceanalysis.items.findIndex(
              (y) => y.FM_CODE == this.removeobj
            );
            this.priceanalysis.items.splice(index, 1);
          }
        })
        .catch((err) => {
          console.warn(err);
        });
    },
    pasrseToOptions(list1) {
      let list2 = [];
      for (let i in list1) {
        let item1 = list1[i];
        let obj = {
          label: item1.FISH_NAME,
          code: item1.FISH_CODE,
        };
        list2.push(obj);
      }
      return list2;
    },
    // getName(code)
    // {
    //     let index = this.fishcodelist.findIndex(y=>y.FISH_CODE == code)
    //     return this.fishcodelist[index].FISH_NAME
    // },
    savelist() {
      this.isBusy = true;
      this.counter = 0;
      this.total = 0;
      this.editlist = [];
      let datelist1 = [];
      if (this.priceanalysis.items.length != 0) {
        let count = 0;
        datelist1 = this.priceanalysis.items[0].FM_DATE.split("-");
        let datelist2 = this.date.split("-");
        datelist2[0] = parseInt(datelist2[0]) + 1911;
        if (datelist2[1].length == 1 && datelist1[1].charAt(0) == "0") {
          datelist1[1] = datelist1[1].charAt(1);
        }
        if (datelist2[2].length == 1 && datelist1[2].charAt(0) == "0") {
          datelist1[2] = datelist1[2].charAt(1);
        }
        for (let k in datelist1) {
          if (datelist1[k] == datelist2[k]) {
            count++;
          }
        }
        if (count == 3) {
          for (let j in this.priceanalysis.items) {
            let item1 = this.priceanalysis.items[j];
            let index1 = this.fishcodelist.findIndex(
              (x) => x.FISH_CODE == item1.FM_CODE
            );
            let subitem = this.fishcodelist[index1];
            let obj = item1;
            obj["FISH_NAME"] = subitem.FISH_NAME;
            obj["FM_SORT"] = parseInt(j) + 1;
            obj["FM_ISDEL"] = 0;
            obj["FM_DATE"] = datelist2.join("-");
            obj["FM_PRICE_L"] = parseFloat(item1.FM_PRICE_L);
            obj["FM_PRICE_R"] = parseFloat(item1.FM_PRICE_R);
            obj["FM_PRICE_L_TW"] = parseFloat(item1.FM_PRICE_L_TW);
            obj["FM_PRICE_R_TW"] = parseFloat(item1.FM_PRICE_R_TW);
            // obj['TokenID'] = this.TokenID
            obj["Token"] = this.Token;
            obj["Page"] = this.page;
            if (this.IsNull(obj["FM_ID"]) == "") {
              this.total++;
              this.FunctionToken(this.InsertFishManagement, obj);
            } else if (this.IsNull(obj["FM_ID"]) != "") {
              this.editlist.push(obj);
            }
          }
          if (this.editlist.length != 0) {
            this.total++;
            this.FunctionToken(this.updateFishManagement, this.editlist);
          }
        } else if (count != 3) {
          for (let j in this.priceanalysis.items) {
            let item1 = this.priceanalysis.items[j];
            let index1 = this.fishcodelist.findIndex(
              (x) => x.FISH_CODE == item1.FM_CODE
            );
            let subitem = this.fishcodelist[index1];
            let obj = item1;
            obj["FM_ID"] = "";
            obj["FISH_NAME"] = subitem.FISH_NAME;
            obj["FM_DATE"] = datelist2.join("-");
            //obj["FM_PRICE"] = parseFloat(item1.FM_PRICE);
            obj["FM_PRICE_L"] = parseFloat(item1.FM_PRICE_L);
            obj["FM_PRICE_R"] = parseFloat(item1.FM_PRICE_R);
            obj["FM_PRICE_L_TW"] = parseFloat(item1.FM_PRICE_L_TW);
            obj["FM_PRICE_R_TW"] = parseFloat(item1.FM_PRICE_R_TW);
            obj["FISH_SPEC"] = item1.FISH_SPEC;
            obj["FM_NOTES"] = item1.FM_NOTES;
            obj["FM_SORT"] = parseInt(j) + 1;
            obj["FM_ISDEL"] = 0;
            // obj['TokenID'] = this.TokenID
            obj["Token"] = this.Token;
            obj["Page"] = this.page;
            this.total++;
            this.FunctionToken(this.InsertFishManagement, obj);
          }
        }
      }
      if (this.priceanalysis.removelist.length != 0) {
        let list2 = [];
        for (let k in this.priceanalysis.removelist) {
          let item2 = this.priceanalysis.removelist[k];
          let obj = item2;
          obj["FM_ISDEL"] = 1;
          // obj['TokenID'] = this.TokenID
          obj["Token"] = this.Token;
          obj["Page"] = this.page;
          list2.push(obj);
        }
        this.total++;
        this.FunctionToken(this.updateFishManagement, list2);
      }
    },
    checkIfdone() {
      let num = this.priceanalysis.items.length;
      if (this.counter == num) {
        this.suceessPopUp("儲存成功");
        this.isBusy = false;
        this.$router.push({ path: "/databuildforfishcatch" });
      }
    },
    checkIfdone2() {
      if (this.counter == this.total) {
        this.suceessPopUp("儲存成功");
        this.isBusy = false;
        this.$router.push({ path: "/databuildforfishcatch" });
      }
    },
    datechange() {
      let localmintime = this.date.split("-");
      localmintime[0] = parseInt(localmintime[0]) + 1911;
      let obj = {
        FM_DATE: localmintime.join("-"),
      };
      this.FunctionToken(this.getFishManagement, obj);
    },
    // async checkPermission() {
    //   let accountdata = { PJ_ID: "PJ000000000014", fun: this.checkshowByPJID };
    //   this.FunctionToken(this.Authority, accountdata);
    //   let databuilddata = {
    //     PJ_ID: "PJ000000000015",
    //     fun: this.checkeditdataByPJID,
    //   };
    //   this.FunctionToken(this.Authority, databuilddata);
    // },
    // checkshowByPJID(value) {
    //   if (!value) {
    //     alert("無權限檢視此頁面，將返回首頁");
    //     this.datamanagement.ifshow = false;
    //     this.$router.push({ path: "/" });
    //   } else {

    //     this.datamanagement.ifshow = true;
    //     this.FunctionToken(this.getTradeWarningCrop, {});
    //   }
    // },
    checkeditdataByPJID(value) {
      if (!value) {
        this.datamanagement.ifedit = false;
      } else {
        this.datamanagement.ifedit = true;
      }
    },
    checksave(item) {
      if (this.IsNull(item.TC_LIMIT)) {
        this.priceanalysis.additem = item;
        this.$bvModal.show("savemodal");
      }
    },
    hideModal() {
      this.priceanalysis.additem = {};
      this.$bvModal.hide("addFishModal");
    },
    addProcess() {
      if (this.IsNull(this.fishcatch.selected) == "") {
        alert("請選擇作物");
      }
      // else if(this.priceanalysis.items.findIndex(x=>x.FM_CODE==this.fishcatch.selected.code)!=-1){
      //     alert('此品項已存在')
      // }
      else {
        this.isBusy = true;
        let obj = {
          FM_DATE: this.date,
          FM_CODE: this.fishcatch.selected.code,
          FISH_NAME: this.fishcatch.selected.label,
          FM_SORT: this.priceanalysis.items.length + 1,
          FISH_SPEC: "",
          FM_PRICE_L: 0,
          FM_PRICE_R: 0,
          FM_PRICE_L_TW: 0,
          FM_PRICE_R_TW: 0,
          FM_NOTES: "",
          ifshow: false,
          // ifedit: false
        };
        this.priceanalysis.items.push(obj);
        // this.FunctionToken(this.insertCropManagement, obj)
      }
    },
    // fishcatchChoose() {
    // },
    typeChoose(index) {
      this.fishcatch.selectlist[1] = null;
      this.fishcatch.options2 = this.fishcatch.fishcatchlist[index.code].list;
    },
    saveProcess() {
      let obj = {
        TC_ID: this.priceanalysis.additem.TC_ID,
        TC_LIMIT: this.priceanalysis.additem.TC_LIMIT,
      };
      this.FunctionToken(this.updateTradeWarningCrop, obj);
    },
    updateTradeWarningCrop(data) {
      this.apiUpdateTradeWarningCrop(data)
        .then((res) => {
          const json = JSON.parse(res.data);
          if (json.Status) {
            this.suceessPopUp("儲存成功");
          }
        })
        .catch((err) => {
          console.warn(err);
        });
    },
    getTradeWarningCrop(data) {
      this.apiGetTradeWarningCrop(data)
        .then((res) => {
          const json = JSON.parse(res.data);
          let jsonData = JSON.parse(json.Data);
          if (json.Status) {
            this.priceanalysis.items = jsonData;
            this.addcount();
            this.isBusy = false;
          }
        })
        .catch((err) => {
          console.warn(err);
        });
    },
    addcount() {
      for (let i in this.priceanalysis.items) {
        this.priceanalysis.items[i]["Count"] = parseInt(i) + 1;
      }
    },
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    suceessPopUp(msg) {
      this.messageObject.success.count = this.messageObject.dismissSecs;
      this.messageObject.success.content = msg;
    },
    successCountChanged(count) {
      this.messageObject.success.count = count;
    },
    unitTransfer(value, index, index2) {
      if (index == 0) {
        if (index2 == 0)
          value.FM_PRICE_L_TW = Math.round(value.FM_PRICE_L * 0.6);
        else if (index2 == 1)
          value.FM_PRICE_R_TW = Math.round(value.FM_PRICE_R * 0.6);
      } else if (index == 1) {
        if (index2 == 0)
          value.FM_PRICE_L = Math.round(value.FM_PRICE_L_TW / 0.6);
        else if (index2 == 1)
          value.FM_PRICE_R = Math.round(value.FM_PRICE_R_TW / 0.6);
      }
    },
  },
  computed: {
    visibleFields() {
      return this.priceanalysis.fields.filter((field) => field.visible);
    },
  },
  watch: {
    date() {
      if (!this.iffirst) {
        this.datechange();
      }
      this.iffirst = false;
    },
  },
};
</script>

<style scoped>
.table thead th {
  vertical-align: middle !important;
}
.hideheadr {
  background-color: red !important;
}
</style>
